import { z } from 'zod';

// Режими іспиту — синхронізовано з ExamMode у Prisma
export const ExamModeSchema = z.enum([
  'CATEGORY',
  'OFFICIAL_20',
  'RANDOM_20',
  'HARDEST_100',
  'MISTAKES',
  'BOOKMARKS',
  'MARATHON',
]);
export type ExamMode = z.infer<typeof ExamModeSchema>;

// Стандартний пагіновачний запит
export const PaginationSchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(20),
  offset: z.coerce.number().int().min(0).default(0),
});
